import React, { Component } from "react";
import { goBack, executePost, executeGet } from "../functions/Kubuku";
import { BASE_URL, TITIK_BACA, TITIK_BACA_CEKLOKASI } from "../api";
import Glider from "react-glider";
import "glider-js/glider.min.css";
import SkeletonBookDetail from "../components/SkeletonBookDetail";
import QRCode from "react-qr-code";
import noCover from "../assets/images/no-cover.png";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import image_location from "../assets/images/location.png";
import { disableSplashScreen } from "../api/enkripsi";
import logoBpEdu from "../assets/images/logo-bintangpusnas-master.png";

function WithNavigate(props) {
  let navigate = useNavigate();
  return <DetailBooks {...props} navigate={navigate} params={useParams()} />;
}

class DetailBooks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isModal: false, //popup loading
      showMain: false,
      params: this.props.params,
      data: "",
      datar: "",
      dataRekomendasi: "",
      dataPenyumbang: "",
      dataterdekat: "",
      alias: this.props.params.alias, //window.localStorage.getItem('alias'), //this.props.params.alias,
      lokasi: "",
      lat: "-7.557130246009252",
      long: "110.79448368501073",
      alt: "1",
      flagData: false,
      flagBaca: false,
      flagBuku: false,
      flagBukuR: false,
      flagJauh: false,
      msgJauh:
        "Maaf saat ini anda sudah diluar jangkauan, silahkan pilih titik baca di sekitar anda.",
      clamp: "line-clamp-6",
      more: "Selengkapnya",
      urlbuku: "",
      hdr: "",
      color: "bg-orange",
      darkcolor: "bg-orang-dark",
      textcolor: "text-orange",
      imgHead: "",
      imgSplash: "",
      mbButton: "mb-0",
      mbKonten: "mb-0",
      uuid: "",
      hashtag: "",
      activeTab: "tab1",
      qty: "",
      sisa: "",
      bpEdu: false,
      showAppNotInstalled: false,
    };
    this.timee = null;
  }

  componentDidMount = async () => {
    // Set state awal
    this.setState({
      alias: this.props.params.alias,
      uuid: localStorage.getItem("uuid"),
      mbButton: this.props.params.token !== "REG" ? "" : this.state.mbButton,
      mbKonten:
        this.props.params.token !== "REG" ? "mb-20" : this.state.mbKonten,
    });

    try {
      const p3smpt = localStorage.getItem("P3SMPT");
      if (p3smpt == "sma") {
        this.setState({
          color: "bg-sma",
          textcolor: "text-sma",
        });
      } else if (p3smpt == "smp") {
        this.setState({
          color: "bg-smp",
          textcolor: "text-smp",
        });
      }
      // Jalankan proses yang tidak saling bergantung secara paralel
      const themePromise = this.getTheme();
      const locationPromise = this.getLocation();

      // Tunggu semua selesai
      await Promise.all([themePromise, locationPromise]);

      // Setelah semua siap, matikan splash screen
      disableSplashScreen();

      // Cek dan handle sesuatu
      this.checkAndHandle();
    } catch (error) {
      console.error("Error in componentDidMount:", error);
      disableSplashScreen(); // Tetap matikan splash screen agar user tidak terjebak
    }
    this.locationInterval = setInterval(() => {
      this.getLocation();
    }, 600000); // 10 menit
  };

  componentDidUpdate(prevProps) {
    clearInterval(this.locationInterval);

    if (prevProps.params.id !== this.props.params.id) {
      this.checkAndHandle();
    }
  }

  checkAndHandle = () => {
    const { params } = this.props;

    if (!params.id) return;

    const sn = localStorage.getItem("sn");
    if (sn && sn !== "null") {
      this.timer = setTimeout(() => {
        this.handleHiddenButtonNav();
      }, 200);
    }
  };

  handleHiddenButtonNav = () => {
    if (window.electron && window.electron.sendMessage) {
      window.electron.sendMessage("DETAILBOOK_MENU", { dummy: 1 });
    } else {
      console.error("window.electron or sendMessage is undefined");
    }
  };

  getTheme = async () => {
    try {
      //const json = await executeGet(TITIK_BACA_GET_THEMES + alias);
      if (window.localStorage.getItem("themes") != null) {
        const ljson = window.localStorage.getItem("themes");
        const json = JSON.parse(ljson);
        if (json.code == 200) {
          if (json.warna != "") {
            this.setState({
              color: json.warna,
            });
          }
          if (json.dark != "") {
            this.setState({
              darkcolor: json.dark,
            });
          }
          if (json.text != "") {
            this.setState({
              textcolor: json.text,
            });
          }
          if (json.head != "") {
            this.setState({
              imgHead: json.head,
            });
          }
          if (json.splash != "") {
            this.setState({
              imgSplash: json.splash,
            });
          }
        }
      }
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  getLocation = () => {
    const lat = localStorage.getItem("lat");
    const long = localStorage.getItem("long");
    const alt = localStorage.getItem("alt");
    const lastLocationTime = localStorage.getItem("lastLocationTime");

    const cacheValid =
      lat && lastLocationTime && Date.now() - lastLocationTime < 1 * 60 * 1000;

    // 1️⃣ Jika ada SN → langsung getBukuPopuler
    if (localStorage.getItem("sn")) {
      this.getBukuPopuler(lat, long, alt);
      return;
    }

    // 2️⃣ Jika ada lokasi di cache → validasi langsung
    if (cacheValid) {
      this.handleLocation(lat, long, alt, false);
      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.handleLocation(
            position.coords.latitude,
            position.coords.longitude,
            position.coords.altitude,
            true,
          );
        },
        (error) => {
          console.warn("Gagal ambil lokasi cache: ", error);
          if (lat) {
            console.warn("Pakai lokasi cache lama");
            this.handleLocation(lat, long, alt, true);
          } else {
            console.warn("tidak ada gps");
          }
        },
      );
    }
  };

  handleLocation = (lat, long, alt, isFresh) => {
    this.setState({ lat, long, alt });
    if (isFresh) {
      localStorage.setItem("lat", lat);
      localStorage.setItem("long", long);
      localStorage.setItem("alt", alt);
      localStorage.setItem("lastLocationTime", Date.now());
    }

    this.validasiLokasi(lat, long, alt);
  };

  validasiLokasi = async (lat, long, alt) => {
    if (this.props.params.token === "REG") {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("alt", alt);

      const json = await executePost(
        TITIK_BACA_CEKLOKASI + this.state.alias,
        formData,
      );

      if (json.code === 400) {
        this.getTitikBacaTerdekat(lat, long, alt);
      } else {
        this.getBukuPopuler(lat, long, alt);
      }

      // 🔄 Interval cek lokasi tiap 30 detik
      let interval = setInterval(async () => {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            let latx = position.coords.latitude;
            let longx = position.coords.longitude;
            let altx = position.coords.altitude;

            let formData = new FormData();
            formData.append("latitude", latx);
            formData.append("longitude", longx);
            formData.append("altitude", altx);

            const json = await executePost(
              TITIK_BACA_CEKLOKASI + this.state.alias,
              formData,
            );

            if (json.code === 400) {
              this.setState({ flagData: false });

              try {
                let formData2 = new FormData();
                formData2.append("latitude", latx);
                formData2.append("longitude", longx);
                formData2.append("altitude", altx);

                const jsonx = await executePost(TITIK_BACA, formData2);
                this.setState({
                  isLoading: false,
                  flagJauh: true,
                  dataterdekat: jsonx,
                });
              } catch (error) {
                this.setState({
                  isError: true,
                  errorMessage: "Network Error!",
                });
              }
              clearInterval(interval);
            }
          },
          (error) => {
            console.warn("Gagal update lokasi di interval:", error);
          },
        );
      }, 30000);
    } else {
      this.getDetailBuku(lat, long);
    }
  };

  getTitikBacaTerdekat = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      const json = await executePost(TITIK_BACA, formData);
      this.setState({
        isLoading: false,
        flagJauh: true,
        dataterdekat: json,
      });
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  getCache = (key) => {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);
      const now = Date.now();
      if (parsed.expiry && parsed.expiry < now) {
        localStorage.removeItem(key); // cache expired
        return null;
      }
      return parsed.data;
    } catch (e) {
      localStorage.removeItem(key);
      return null;
    }
  };

  setCache = (key, data, ttl = 10 * 60 * 1000) => {
    const expiry = Date.now() + ttl;
    localStorage.setItem(key, JSON.stringify({ data, expiry }));
  };

  getDetailBuku = async (lat, long) => {
    try {
      const { alias, params } = this.state;
      const cacheKey = `detailBuku_${alias}_${params.id}_${params.tipe}`;

      // ✅ Cek cache
      const cached = this.getCache(cacheKey); // gunakan getCache dari utility sebelumnya
      if (cached) {
        this.setState({
          data: cached.data,
          hdr: "Buku Detail",
          flagData: true,
          isLoading: false,
          judul: cached.judul,
          bpEdu: cached.bpEdu,
          dataPenyumbang: cached.dataPenyumbang,
          datar: cached.datar,
          flagBukuR: cached.flagBukuR,
          hashtag: cached.hashtag,
          sisa: cached.sisa,
          qty: cached.qty,
        });
        return; // stop fetch
      }

      this.setState({ isLoading: true });

      const formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("isMobile", "1");

      const json = await executeGet(
        `${BASE_URL}getListBuku/${alias}/${params.id}/${params.tipe}`,
      );

      if (json.code == 404) {
        // window.location.href = "https://titikbaca.id";
        return;
      }

      let stateData = {
        hdr: "Buku Detail",
        flagData: true,
        isLoading: false,
      };

      if (params.tipe == "kontenLokal") {
        stateData = {
          ...stateData,
          data: json.data,
          judul: json.data.judul,
          bpEdu: json.data.bp_edu,
        };
      } else {
        stateData = {
          ...stateData,
          data: json,
          judul: json.judul,
          dataPenyumbang: json?.penyumbang,
          datar: json?.rekomendasi,
          flagBukuR: true,
          hashtag: json?.hashtag,
          sisa: json.sisa,
          qty: json.qty,
          bpEdu: json.bp_edu == 1,
        };
      }

      this.setState(stateData, () => {
        // ✅ Simpan cache TTL 10 menit
        this.setCache(cacheKey, stateData);
      });
    } catch (error) {
      console.error(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  getBukuPopuler = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", "1");
      const json = await executePost(TITIK_BACA + this.state.alias, formData);
      if (json.code == 404) {
        window.location.href = "https://titikbaca.id";
      } else if (json.code == 200) {
        this.setState({
          lokasi: json.nama_lokasi,
          dataRekomendasi: json.data,
          alias: json.token,
          flagBukuR: true,
        });
        this.getDetailBuku(lat, long);
      } else {
        this.setState({
          flagJauh: true,
          flagData: false,
          flagBukuR: false,
          isLoading: false,
        });
      }
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  togleClamp = () => {
    if (this.state.clamp === "") {
      this.setState({
        clamp: "line-clamp-6",
        more: "Selengkapnya",
      });
    } else {
      this.setState({
        clamp: "",
        more: "Ringkas",
      });
    }
  };

  gotoDetail = async (id) => {
    let aid = id.split("-");
    id = aid[aid.length - 1];
    window.location.href =
      "/detail/konten/" +
      id +
      "/" +
      this.state.alias +
      "/" +
      this.props.params.token;
  };

  gotoBaca = async (id, kode, jenis) => {
    if (jenis < 7) {
      if (this.props.params.token == "REG") {
        window.location.href =
          "/bacaBuku/" +
          id +
          "/" +
          this.state.alias +
          "/" +
          encodeURIComponent(this.state.data.judul) +
          "/" +
          jenis +
          "/" +
          this.props.params.token;
      } else {
        window.location.href =
          "/bacaBukuKeluarga/" +
          id +
          "/" +
          this.state.alias +
          "/" +
          encodeURIComponent(this.state.data.judul) +
          "/" +
          jenis +
          "/" +
          this.props.params.token;
      }
    } else if (jenis == 11) {
      if (this.props.params.token == "REG") {
        this.props.navigate(
          "/bacaBuku/" +
            kode +
            "/" +
            this.state.alias +
            "/" +
            encodeURIComponent(this.state.data.judul) +
            "/" +
            jenis +
            "/" +
            this.props.params.token,
        );
      } else {
        this.props.navigate(
          "/bacaBukuKeluarga/" +
            kode +
            "/" +
            this.state.alias +
            "/" +
            encodeURIComponent(this.state.data.judul) +
            "/" +
            jenis +
            "/" +
            this.props.params.token,
        );
      }
    } else {
      this.props.navigate("/audioplayer/" + kode);
    }
  };

  goToBacaSr = async (id, kode, token, jenis) => {
    const segments = window.location.pathname.split("/");
    const konten = segments[2];

    let tipe = "ebook";
    let platform = "titikbaca";
    let kodeKonten = id;

    if (this.state.bpEdu) {
      platform = "bpedu";
      kodeKonten = kode;
    } else {
      platform = this.state.alias;
      kodeKonten = id;
    }

    const upperKode = (kodeKonten || "").toString().toUpperCase();

    if (upperKode.includes("AUD")) {
      tipe = "audio";
    } else if (upperKode.includes("VID")) {
      tipe = "video";
    } else {
      tipe = "ebook";
    }

    let deepLink;

    if (konten === "kontenLokal") {
      deepLink = `bintangpusnas://reader?token=${token}&titikbaca=${platform}&tipe=${tipe}&kode_konten=${kodeKonten}&local=1`;
    } else {
      deepLink = `bintangpusnas://reader?token=${token}&titikbaca=${platform}&tipe=${tipe}&kode_konten=${kodeKonten}`;
    }

    const start = Date.now();

    window.location.href = deepLink;

    setTimeout(() => {
      const elapsed = Date.now() - start;

      if (elapsed < 2000) {
        this.setState({ showAppNotInstalled: true });
      }
    }, 1500);
  };

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    //let url = window.location.origin + "/detail/" + this.props.params.tipe + "/" +this.props.params.id + "/" + this.props.params.alias;
    let url =
      "https://titikbaca.perpusnas.go.id/detail/" +
      this.props.params.tipe +
      "/" +
      this.props.params.id +
      "/" +
      this.props.params.alias;

    const { activeTab } = this.state;

    return (
      <>
        <div>
          <nav className="fixed top-0 w-full z-10 shadow-md">
            <div
              onClick={() => goBack()}
              className={
                "flex p-4 " +
                this.state.color +
                " text-lg text-white font-semibold items-center"
              }
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-8"
              >
                <path
                  d="M15 6L9 12L15 18"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="line-clamp-1 "> {this.state.hdr}</span>
            </div>
          </nav>
          {this.state.isLoading && <SkeletonBookDetail />}
          {this.state.flagJauh && (
            <>
              <div className="mt-16">
                <div className="px-4">
                  <div
                    className={
                      "relative mb-2.5 p-4 " +
                      this.state.color +
                      "text-white rounded-2xl shadow-md overflow-hidden"
                    }
                  >
                    <div className="w-52 sm:w-96 md:w-auto">
                      <p className="mb-3 text-sm font-semibold">
                        {this.state.msgJauh}
                      </p>
                    </div>
                    <svg
                      width="64"
                      height="68"
                      viewBox="0 0 64 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="absolute right-2.5 top-1 z-10"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.6379 67.2934C11.1472 67.2934 24.8452 63.913 24.8452 63.913L38.4521 62.7157L55.4457 62.4841L49.3253 29.5515L45.2892 20.5968L10.6379 62.3136C10.6379 62.3136 9.344 67.2934 10.6379 67.2934Z"
                        fill="url(#paint0_linear_176_439)"
                      />
                      <mask
                        id="path-2-outside-1_176_439"
                        maskUnits="userSpaceOnUse"
                        x="1.61022"
                        y="15.8526"
                        width="52.6296"
                        height="52.6296"
                        fill="black"
                      >
                        <rect
                          fill="white"
                          x="1.61022"
                          y="15.8526"
                          width="52.6296"
                          height="52.6296"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M32.515 24.8062L45.4709 18.1441C45.6726 18.0404 45.9167 18.1642 45.9522 18.3882L51.6594 54.4217C51.6819 54.5638 51.6106 54.7043 51.4827 54.7701L38.4566 61.4683C38.4141 61.4901 38.3697 61.5019 38.3257 61.5047C38.2838 61.515 38.2388 61.5173 38.1926 61.5098L23.8116 59.1773L10.8553 65.8397C10.6536 65.9434 10.4094 65.8196 10.3739 65.5955L4.66678 29.562C4.64427 29.42 4.71552 29.2795 4.84346 29.2137L17.8696 22.5155C17.9117 22.4938 17.9556 22.4821 17.9991 22.4791C18.0415 22.4685 18.087 22.4661 18.1337 22.4736L32.515 24.8062Z"
                        />
                      </mask>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M32.515 24.8062L45.4709 18.1441C45.6726 18.0404 45.9167 18.1642 45.9522 18.3882L51.6594 54.4217C51.6819 54.5638 51.6106 54.7043 51.4827 54.7701L38.4566 61.4683C38.4141 61.4901 38.3697 61.5019 38.3257 61.5047C38.2838 61.515 38.2388 61.5173 38.1926 61.5098L23.8116 59.1773L10.8553 65.8397C10.6536 65.9434 10.4094 65.8196 10.3739 65.5955L4.66678 29.562C4.64427 29.42 4.71552 29.2795 4.84346 29.2137L17.8696 22.5155C17.9117 22.4938 17.9556 22.4821 17.9991 22.4791C18.0415 22.4685 18.087 22.4661 18.1337 22.4736L32.515 24.8062Z"
                        fill="#ADE1F1"
                      />
                      <path
                        d="M45.4709 18.1441L46.0802 19.3291L46.0802 19.3291L45.4709 18.1441ZM32.515 24.8062L32.3016 26.1215L32.7344 26.1917L33.1243 25.9912L32.515 24.8062ZM45.9522 18.3882L44.6361 18.5967L45.9522 18.3882ZM51.6594 54.4217L52.9755 54.2133L51.6594 54.4217ZM51.4827 54.7701L50.8733 53.5851L50.8733 53.5851L51.4827 54.7701ZM38.4566 61.4683L37.8472 60.2832L37.8472 60.2832L38.4566 61.4683ZM38.3257 61.5047L38.2399 60.175L38.1219 60.1826L38.0071 60.2109L38.3257 61.5047ZM38.1926 61.5098L38.406 60.1945L38.4059 60.1945L38.1926 61.5098ZM23.8116 59.1773L24.025 57.862L23.5922 57.7918L23.2023 57.9923L23.8116 59.1773ZM10.8553 65.8397L10.2459 64.6546L10.2459 64.6546L10.8553 65.8397ZM10.3739 65.5955L9.05782 65.804L10.3739 65.5955ZM4.66678 29.562L5.98287 29.3536L4.66678 29.562ZM4.84346 29.2137L5.45281 30.3987L5.45281 30.3987L4.84346 29.2137ZM17.8696 22.5155L18.4789 23.7005L18.4789 23.7005L17.8696 22.5155ZM17.9991 22.4791L18.0902 23.8085L18.2087 23.8004L18.3238 23.7715L17.9991 22.4791ZM18.1337 22.4736L17.9204 23.789L17.9204 23.789L18.1337 22.4736ZM44.8615 16.9591L31.9056 23.6212L33.1243 25.9912L46.0802 19.3291L44.8615 16.9591ZM47.2683 18.1798C47.0909 17.0596 45.8701 16.4404 44.8615 16.9591L46.0802 19.3291C45.475 19.6403 44.7426 19.2688 44.6361 18.5967L47.2683 18.1798ZM52.9755 54.2133L47.2683 18.1798L44.6361 18.5967L50.3433 54.6302L52.9755 54.2133ZM52.092 55.9551C52.7317 55.6262 53.088 54.9237 52.9755 54.2133L50.3433 54.6302C50.2757 54.2039 50.4895 53.7824 50.8733 53.5851L52.092 55.9551ZM39.0659 62.6533L52.092 55.9551L50.8733 53.5851L37.8472 60.2832L39.0659 62.6533ZM38.4116 62.8345C38.6358 62.82 38.8587 62.7599 39.0659 62.6533L37.8472 60.2832C37.9695 60.2204 38.1035 60.1838 38.2399 60.175L38.4116 62.8345ZM37.9793 62.8251C38.2046 62.8617 38.4305 62.8512 38.6444 62.7986L38.0071 60.2109C38.1371 60.1789 38.2731 60.173 38.406 60.1945L37.9793 62.8251ZM23.5983 60.4926L37.9793 62.8251L38.4059 60.1945L24.025 57.862L23.5983 60.4926ZM11.4646 67.0247L24.421 60.3623L23.2023 57.9923L10.2459 64.6546L11.4646 67.0247ZM9.05782 65.804C9.23524 66.9242 10.456 67.5433 11.4646 67.0247L10.2459 64.6546C10.8511 64.3434 11.5836 64.7149 11.69 65.3871L9.05782 65.804ZM3.35068 29.7705L9.05782 65.804L11.69 65.3871L5.98287 29.3536L3.35068 29.7705ZM4.23412 28.0287C3.59442 28.3576 3.23815 29.06 3.35068 29.7705L5.98287 29.3536C6.05039 29.7799 5.83662 30.2013 5.45281 30.3987L4.23412 28.0287ZM17.2602 21.3305L4.23411 28.0287L5.45281 30.3987L18.4789 23.7005L17.2602 21.3305ZM17.908 21.1497C17.686 21.165 17.4655 21.2249 17.2602 21.3305L18.4789 23.7005C18.3579 23.7628 18.2252 23.7993 18.0902 23.8085L17.908 21.1497ZM18.3471 21.1583C18.119 21.1213 17.8905 21.1325 17.6744 21.1868L18.3238 23.7715C18.1925 23.8045 18.0549 23.8108 17.9204 23.789L18.3471 21.1583ZM32.7283 23.4909L18.3471 21.1583L17.9204 23.789L32.3016 26.1215L32.7283 23.4909Z"
                        fill="url(#paint1_linear_176_439)"
                        mask="url(#path-2-outside-1_176_439)"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.66673 29.5618C4.64423 29.4197 4.71548 29.2792 4.84342 29.2134L17.8695 22.5152C18.0712 22.4115 18.3154 22.5353 18.3509 22.7594L24.058 58.7928C24.0805 58.9349 24.0093 59.0754 23.8813 59.1412L10.8552 65.8394C10.6535 65.9431 10.4094 65.8193 10.3739 65.5952L4.66673 29.5618Z"
                        fill="#ADE1F1"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.09232 51.4391C8.06938 51.2967 8.14064 51.1558 8.26886 51.0898L21.2955 44.3914C21.4969 44.2878 21.7407 44.4111 21.7767 44.6346L24.0574 58.7925C24.0803 58.9349 24.0091 59.0758 23.8808 59.1418L10.8542 65.8402C10.6528 65.9438 10.409 65.8205 10.373 65.597L8.09232 51.4391Z"
                        fill="#ADF1AF"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M32.2675 25.1904C32.245 25.0483 32.3162 24.9078 32.4442 24.842L45.4703 18.1438C45.672 18.0401 45.9161 18.1639 45.9516 18.388L51.6588 54.4214C51.6813 54.5635 51.61 54.704 51.4821 54.7698L38.456 61.468C38.2542 61.5717 38.0101 61.4479 37.9746 61.2238L32.2675 25.1904Z"
                        fill="#ADE1F1"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M35.7741 47.4515L40.9383 49.9914L49.948 45.6178C50.1508 45.5193 50.3908 45.6466 50.4231 45.8697L51.6627 54.4244C51.6831 54.5652 51.6118 54.7034 51.4853 54.7684L38.4557 61.4684C38.2541 61.5721 38.0102 61.4485 37.9744 61.2247L35.7741 47.4515Z"
                        fill="#ADF1AF"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M32.8678 25.0954C32.8453 24.9533 32.7341 24.8417 32.5921 24.8187L18.1337 22.4737C17.9098 22.4373 17.7159 22.6305 17.7514 22.8546L23.4585 58.8881C23.481 59.0302 23.5922 59.1417 23.7342 59.1648L38.1926 61.5098C38.4165 61.5462 38.6104 61.3529 38.575 61.1289L32.8678 25.0954Z"
                        fill="#9AD6E9"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M32.0645 46.6664C31.9427 46.6323 31.8508 46.5321 31.8272 46.4078L30.3691 38.7273L20.521 37.13C20.2975 37.0937 20.1037 37.2862 20.1385 37.5099L23.4589 58.8872C23.481 59.0297 23.5924 59.1418 23.7347 59.1649L38.1938 61.5101C38.4173 61.5463 38.6111 61.3539 38.5763 61.1301L36.524 47.9167L32.0645 46.6664Z"
                        fill="#9AE99C"
                      />
                      <path
                        d="M7.23277 51.1431L20.676 44.7826L19.2484 36.6147L22.622 37.2337L30.6277 38.166L31.9741 46.7593L35.9355 47.4374L40.8225 49.9634L50.9682 45.1766"
                        stroke="white"
                        strokeWidth="1.99876"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M19.2552 39.0684L13.969 37.8863L12.7439 30.9982L15.9964 29.1204L15.2151 23.5279"
                        stroke="white"
                        strokeWidth="0.999378"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.7783 48.8492L18.4118 52.3718L22.2743 50.6138L37.0916 53.2579L38.4154 62.3491"
                        stroke="white"
                        strokeWidth="0.999378"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M31.1092 38.1142L29.9326 29.2229L33.4327 30.0079L37.9876 36.2505L45.429 32.8135L47.892 26.0709"
                        stroke="white"
                        strokeWidth="0.999378"
                        stroke-linejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.6699 51.4015L26.8934 38.3246L30.717 36.8811L33.2266 38.3246L44.996 21.2019H47.7272L52.6699 51.4015Z"
                        fill="url(#paint2_linear_176_439)"
                      />
                      <path
                        d="M11.3957 9.00499L7.19757 6.21516C6.75746 5.92269 6.16816 6.04226 5.88133 6.48224C5.5945 6.92222 5.71876 7.51599 6.15888 7.80846L10.357 10.5983C10.7971 10.8908 11.3864 10.7712 11.6732 10.3312C11.9601 9.89123 11.8358 9.29746 11.3957 9.00499Z"
                        fill="url(#paint3_linear_176_439)"
                      />
                      <path
                        d="M9.17086 12.5428L4.20095 11.7017C3.67993 11.6136 3.19021 11.9625 3.10714 12.4811C3.02406 12.9997 3.37909 13.4916 3.90011 13.5798L8.87002 14.4209C9.39104 14.5091 9.88075 14.1601 9.96383 13.6415C10.0469 13.1229 9.69188 12.631 9.17086 12.5428Z"
                        fill="url(#paint4_linear_176_439)"
                      />
                      <path
                        d="M15.1263 6.83111L12.8855 2.31599C12.6506 1.84264 12.0805 1.65155 11.6121 1.88917C11.1437 2.12679 10.9544 2.70314 11.1893 3.17648L13.4301 7.6916C13.665 8.16495 14.2352 8.35604 14.7036 8.11842C15.1719 7.8808 15.3612 7.30446 15.1263 6.83111Z"
                        fill="url(#paint5_linear_176_439)"
                      />
                      <path
                        d="M51.8027 10.9513L56.4892 9.09526C56.9805 8.90068 57.532 9.14017 57.7211 9.63017C57.9102 10.1202 57.6652 10.6751 57.1739 10.8697L52.4875 12.7257C51.9962 12.9203 51.4446 12.6808 51.2555 12.1908C51.0664 11.7008 51.3114 11.1459 51.8027 10.9513Z"
                        fill="url(#paint6_linear_176_439)"
                      />
                      <path
                        d="M53.2436 14.8742L58.2797 15.0848C58.8077 15.1069 59.2142 15.55 59.1876 16.0745C59.161 16.5991 58.7115 17.0064 58.1835 16.9843L53.1474 16.7738C52.6194 16.7517 52.2129 16.3086 52.2395 15.784C52.2661 15.2595 52.7156 14.8521 53.2436 14.8742Z"
                        fill="url(#paint7_linear_176_439)"
                      />
                      <path
                        d="M48.606 8.04883L51.7365 4.09826C52.0647 3.6841 52.6621 3.61572 53.0709 3.94553C53.4796 4.27534 53.5449 4.87844 53.2167 5.2926L50.0862 9.24318C49.758 9.65734 49.1606 9.72572 48.7518 9.39591C48.3431 9.0661 48.2778 8.46299 48.606 8.04883Z"
                        fill="url(#paint8_linear_176_439)"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M27.3044 11.3795C27.1368 11.3917 26.9686 11.4082 26.8001 11.4289C21.1538 12.1222 17.1478 17.3364 17.8524 23.0753C17.9651 23.9931 18.1915 24.8688 18.5154 25.6895L18.5143 25.6926C20.0497 29.6808 22.891 35.1914 27.765 39.0794C29.209 38.7023 30.5699 38.4799 30.6307 38.4701L29.2529 27.2491C29.0895 27.2859 28.9228 27.3149 28.7531 27.3357C25.9762 27.6767 23.4478 25.6951 23.1058 22.9096C22.7638 20.1242 24.7377 17.5898 27.5145 17.2488C27.6843 17.228 27.8531 17.2158 28.0205 17.212L27.3044 11.3795Z"
                        fill="url(#paint9_linear_176_439)"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M24.9399 11.7183C24.7726 11.7307 24.6048 11.7471 24.4365 11.7678C18.7902 12.4611 14.7767 17.6144 15.4721 23.2781C15.6328 24.5866 16.0308 25.8079 16.6174 26.9039C19.7239 33.2724 27.7983 39.1472 27.7983 39.1472C27.7983 39.1472 27.9615 38.9574 28.2418 38.61L26.8551 27.316C26.6919 27.3528 26.5253 27.3818 26.3558 27.4026C23.5789 27.7435 21.0506 25.7619 20.7086 22.9765C20.3665 20.1911 22.3404 17.6566 25.1173 17.3157C25.2868 17.2949 25.4554 17.2827 25.6227 17.2789L24.9399 11.7183Z"
                        fill="url(#paint10_linear_176_439)"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M33.7989 11.6568C33.9667 11.6633 34.1353 11.674 34.3044 11.6888C39.9608 12.1836 44.1466 17.1511 43.6538 22.7839C43.5357 24.134 43.1596 25.3997 42.5779 26.5372C40.9217 30.3424 37.868 34.074 33.7141 38.7611C32.9238 38.4632 31.5793 37.9702 31.5793 37.9702C31.5793 37.9702 31.553 37.944 31.5035 37.8933L32.446 27.1207C32.6104 27.1518 32.7778 27.175 32.948 27.1899C35.7298 27.4332 38.1833 25.3624 38.4281 22.5646C38.6729 19.7667 36.6162 17.3013 33.8344 17.0579C33.6642 17.043 33.4953 17.0368 33.328 17.0389L33.7989 11.6568Z"
                        fill="url(#paint11_linear_176_439)"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36.0075 11.7924C36.1749 11.7989 36.3431 11.8095 36.5118 11.8242C42.1681 12.3191 46.35 17.3321 45.8523 23.0211C45.7378 24.3299 45.3856 25.5604 44.8422 26.6734C41.969 33.1573 34.1063 39.326 34.1063 39.326C34.1063 39.326 33.9366 39.1416 33.6444 38.8033L34.6368 27.4597C34.8011 27.4907 34.9684 27.5139 35.1384 27.5288C37.9202 27.7722 40.3737 25.7014 40.6185 22.9035C40.8633 20.1056 38.8066 17.6402 36.0248 17.3968C35.8548 17.382 35.686 17.3757 35.5189 17.3778L36.0075 11.7924Z"
                        fill="url(#paint12_linear_176_439)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_176_439"
                          x1="64.8891"
                          y1="61.0799"
                          x2="59.4697"
                          y2="48.3545"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#C8D4DE" stop-opacity="0.01" />
                          <stop offset="1" stopColor="#DEEAF4" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_176_439"
                          x1="-15.7415"
                          y1="44.4627"
                          x2="22.5739"
                          y2="76.7791"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#EFF6FF" />
                          <stop offset="1" stopColor="white" />
                        </linearGradient>
                        <linearGradient
                          id="paint2_linear_176_439"
                          x1="42.1619"
                          y1="44.7031"
                          x2="28.9671"
                          y2="33.6334"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#80C9C7" stop-opacity="0.01" />
                          <stop offset="1" stopColor="#3E80B3" />
                        </linearGradient>
                        <linearGradient
                          id="paint3_linear_176_439"
                          x1="5.38321"
                          y1="6.63295"
                          x2="8.48295"
                          y2="12.225"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#E8F1F5" />
                          <stop offset="1" stopColor="#E5EAF0" />
                        </linearGradient>
                        <linearGradient
                          id="paint4_linear_176_439"
                          x1="2.71338"
                          y1="12.8214"
                          x2="7.81963"
                          y2="16.6692"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#E8F1F5" />
                          <stop offset="1" stopColor="#E5EAF0" />
                        </linearGradient>
                        <linearGradient
                          id="paint5_linear_176_439"
                          x1="11.1053"
                          y1="1.77062"
                          x2="10.9938"
                          y2="8.16337"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#E8F1F5" />
                          <stop offset="1" stopColor="#E5EAF0" />
                        </linearGradient>
                        <linearGradient
                          id="paint6_linear_176_439"
                          x1="58.177"
                          y1="9.88115"
                          x2="53.9823"
                          y2="14.7066"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#E8F1F5" />
                          <stop offset="1" stopColor="#E5EAF0" />
                        </linearGradient>
                        <linearGradient
                          id="paint7_linear_176_439"
                          x1="59.502"
                          y1="16.4893"
                          x2="53.7073"
                          y2="19.1914"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#E8F1F5" />
                          <stop offset="1" stopColor="#E5EAF0" />
                        </linearGradient>
                        <linearGradient
                          id="paint8_linear_176_439"
                          x1="53.5912"
                          y1="3.93493"
                          x2="52.3712"
                          y2="10.2112"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#E8F1F5" />
                          <stop offset="1" stopColor="#E5EAF0" />
                        </linearGradient>
                        <linearGradient
                          id="paint9_linear_176_439"
                          x1="18.8644"
                          y1="15.7599"
                          x2="35.4389"
                          y2="29.3181"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#FF5E84" />
                          <stop offset="1" stopColor="#E46B80" />
                        </linearGradient>
                        <linearGradient
                          id="paint10_linear_176_439"
                          x1="7.81875"
                          y1="52.7655"
                          x2="28.1367"
                          y2="49.9166"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#FFB8C6" />
                          <stop offset="1" stopColor="#FF8194" />
                        </linearGradient>
                        <linearGradient
                          id="paint11_linear_176_439"
                          x1="43.4202"
                          y1="19.2673"
                          x2="27.4514"
                          y2="28.7494"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#FFCFD5" />
                          <stop offset="1" stopColor="#FFA2AB" />
                        </linearGradient>
                        <linearGradient
                          id="paint12_linear_176_439"
                          x1="55.2985"
                          y1="51.5483"
                          x2="34.8552"
                          y2="49.7597"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#FFB8C6" />
                          <stop offset="1" stopColor="#FF8194" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <div className="absolute right-[-40px] top-[-60px] w-36 h-36 bg-white/50 rounded-full"></div>
                  </div>
                </div>

                {/* Title Section */}
                <div className="flex justify-between px-4 items-center mt-4 mb-2">
                  <h3 className="text-base text-black font-semibold">
                    Silahkan Pilih Titikbaca
                  </h3>
                </div>
                {/* End Title Section */}
                <div className="px-4 mb-16">
                  <div className="grid grid-cols-3 md:grid-cols-6 gap-4">
                    {this.state.alias != "kfh-12f9-kas" && (
                      <>
                        <a href={"/kfh-12f9-kas"}>
                          <div className="text-center">
                            <div className="rounded-full p-4">
                              <img src={image_location} alt="location" />
                            </div>
                            <div className="mt-2 text-sm text-black font-semibold line-clamp-2">
                              PT. Enam Kubuku Indonesia
                            </div>
                          </div>
                        </a>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          {this.state.flagData && (
            <>
              <div
                className={
                  "relative mt-[56px] md:-[70px] px-5 py-6 h-56 " +
                  this.state.color +
                  " rounded-b-3xl"
                }
              >
                <img
                  src={this.state.data.cover_file}
                  alt="cover buku"
                  className="absolute w-44 md:w-60 left-[30%] sm:left-[37%] md:left-[43%] rounded-2xl shadow-md"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noCover;
                  }}
                />
              </div>
              <div className="px-4">
                <div className="mt-[20%] sm:mt-[10%] mb-2 text-center">
                  <h3 className="text-xl font-bold text-black line-clamp-2">
                    {this.state.data.judul}
                  </h3>
                  <h4 className="text-sm text-gray-light line-clamp-1">
                    {this.state.data.penulis}
                  </h4>
                  <h4 className="text-sm text-gray-light line-clamp-1">
                    Stok: {this.state.sisa}/{this.state.qty}
                  </h4>
                  {this.state.bpEdu && (
                    <>
                      <h5 className="mt-2 text-gray-light ">
                        Konten: <br />
                        <center>
                          <img
                            className="max-h-[48px] w-40"
                            alt="logo penyumbang"
                            src={logoBpEdu}
                          />
                        </center>
                      </h5>
                    </>
                  )}
                  {Array.isArray(this.state.data?.penyumbang) &&
                    this.state.data.penyumbang.length > 0 && (
                      <>
                        <h5 className="mt-2 text-gray-light ">
                          Donatur: <br />
                          <center>
                            <img
                              className="max-h-[48px]"
                              alt="logo penyumbang"
                              src={this.state.data.penyumbang[0].logo}
                            />
                          </center>
                          <span className="text-black font-semibold">
                            {this.state.data.penyumbang[0].nama}
                          </span>
                        </h5>
                      </>
                    )}
                </div>
                <div className="mb-4">
                  <div className="w-full max-w-[120px] sm:max-w-[180px] mx-auto">
                    <QRCode
                      className="w-full h-auto p-4 rounded-xl shadow-md"
                      value={url + "/" + this.props.params.token}
                      viewBox="0 0 120 120"
                    />
                  </div>
                </div>

                <div className="flex border-b w-52 border-gray-300">
                  <button
                    className={`px-4 py-2 text-sm font-medium ${
                      activeTab === "tab1"
                        ? "border-b-2 border-orange text-blue-500"
                        : "text-gray-500"
                    }`}
                    onClick={() => this.setActiveTab("tab1")}
                  >
                    Deskripsi
                  </button>
                  <button
                    className={`px-4 py-2 text-sm font-medium ${
                      activeTab === "tab2"
                        ? "border-b-2 border-orange text-blue-500"
                        : "text-gray-500"
                    }`}
                    onClick={() => this.setActiveTab("tab2")}
                  >
                    Sinopsis AI
                  </button>
                </div>
                {activeTab === "tab1" && (
                  <>
                    <h3 className="mb-1.5 text-base text-black font-semibold mt-5"></h3>
                    <div className={"text-sm text-black " + this.state.clamp}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            this.state.data.sinopsis == "-"
                              ? "Penerbit belum menyediakan Sinopsis untuk buku ini."
                              : this.state.data.sinopsis,
                        }}
                      />
                    </div>
                    <div className="text-right">
                      <button
                        onClick={() => this.togleClamp()}
                        id="button"
                        className="mt-3 text-orange text-sm duration-300"
                      >
                        {this.state.more}
                      </button>
                    </div>
                  </>
                )}
                {activeTab === "tab2" && (
                  <>
                    <h3 className="mb-1.5 text-base text-black font-semibold mt-5"></h3>
                    <div className={"text-sm text-black " + this.state.clamp}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            this.state.data.ai_sinopsis == "-"
                              ? "Penerbit belum menyediakan Sinopsis untuk buku ini."
                              : this.state.data.ai_sinopsis,
                        }}
                      />
                    </div>
                    <div className="text-right">
                      <button
                        onClick={() => this.togleClamp()}
                        id="button"
                        className="mt-3 text-orange text-sm duration-300"
                      >
                        {this.state.more}
                      </button>
                    </div>
                  </>
                )}

                {Array.isArray(this.state.hashtag) &&
                  this.state.hashtag.length > 0 && (
                    <div className="flex items-center space-x-2 gap-1 flex-wrap mt-3">
                      <div className="text-sm text-black font-semibold">
                        Tags (By AI):
                      </div>
                      {this.state.hashtag.map((tag, index) => (
                        <div
                          onClick={() =>
                            this.props.navigate(
                              `/hashtags/${tag.id}/${tag.hashtag.replaceAll(
                                "#",
                                "",
                              )}/${this.props.params.alias}`,
                            )
                          }
                          key={index}
                          className="bg-orange/20 text-orange text-sm px-2 py-1 rounded-md"
                        >
                          {tag.hashtag}
                        </div>
                      ))}
                    </div>
                  )}
              </div>
              <h3 className="mt-5 mb-1.5 px-4 text-base text-black font-semibold">
                Detail Buku
              </h3>
              <div
                className={
                  "px-4 " + this.state.mbKonten + " grid grid-cols-2 gap-2"
                }
              >
                <div>
                  <div className="text-sm text-black font-semibold">
                    Jumlah Halaman
                  </div>
                  <div className="text-sm text-[#858585]">
                    {this.state.data.halaman_total}
                  </div>
                </div>
                <div>
                  <div className="text-sm text-black font-semibold">
                    Penerbit
                  </div>
                  <div className="text-sm text-[#858585]">
                    {this.state.data.penerbit}
                  </div>
                </div>
                <div>
                  <div className="text-sm text-black font-semibold">
                    Ukuran File
                  </div>
                  <div className="text-sm text-[#858585]">
                    {this.state.data.android_file_size} MB
                  </div>
                </div>
                <div>
                  <div className="text-sm text-black font-semibold">ISBN</div>
                  <div className="text-sm text-[#858585]">
                    {this.state.data.isbn}
                  </div>
                </div>
              </div>
              <div className="px-4 pt-4 mb-8"></div>
              <div
                className={
                  "fixed bottom-0 w-full h-20 " +
                  this.state.mbButton +
                  " md:mb-0 bg-white z-20 p-3 drop-shadow-[0_35px_35px_rgba(0,0,0,0.25)]"
                }
                id="navBaca"
              >
                {this.state.data.id_jenis_konten == 7 ||
                this.state.data.id_jenis_konten == 8 ? (
                  <button
                    type="button"
                    id="bacaBuku"
                    className={
                      "w-full " +
                      this.state.color +
                      " p-3 text-white font-semibold rounded-2xl  md:mb-16"
                    }
                    onClick={() => {
                      if (localStorage.getItem("sr") == "1") {
                        this.goToBacaSr(
                          this.state.data.token,
                          this.state.data.kode,
                          localStorage.getItem("token"),
                          this.state.data.id_jenis_konten,
                        );
                      } else {
                        this.gotoBaca(
                          this.state.data.token,
                          this.state.data.kode,
                          this.state.data.id_jenis_konten,
                        );
                      }
                    }}
                  >
                    Putar
                  </button>
                ) : (
                  <button
                    id="bacaBuku"
                    type="button"
                    className={
                      "w-full " +
                      this.state.color +
                      " p-3 text-white font-semibold rounded-2xl md:mb-16"
                    }
                    onClick={() => {
                      if (localStorage.getItem("sr") == "1") {
                        this.goToBacaSr(
                          this.state.data.token,
                          this.state.data.kode,
                          localStorage.getItem("token"),
                          this.state.data.id_jenis_konten,
                        );
                      } else {
                        this.gotoBaca(
                          this.state.data.token,
                          this.state.data.kode,
                          this.state.data.id_jenis_konten,
                        );
                      }
                    }}
                  >
                    Baca
                  </button>
                )}
              </div>
              {this.state.flagBukuR && (
                <>
                  <div className="flex justify-between px-4 items-center mt-4 mb-2">
                    <h3 className="text-base text-black font-semibold">
                      Buku Rekomendasi
                    </h3>
                  </div>
                  <div className="pl-4 mb-20 sm:block md:hidden">
                    <Glider slidesToShow="3.3" slidesToScroll="1" draggable>
                      {/* <!-- Item Book --> */}
                      {Array.isArray(this.state.dataRekomendasi) &&
                        this.state.dataRekomendasi.length > 0 &&
                        this.state.flagBukuR && (
                          <>
                            {this.state.dataRekomendasi
                              .slice(0, 6)
                              .map((item) => {
                                if (item.alias !== this.state.params.id) {
                                  return (
                                    <>
                                      <div className="p-1">
                                        <div className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                                          <div
                                            className="h-[140px] overflow-hidden"
                                            onClick={() =>
                                              this.gotoDetail(item.alias)
                                            }
                                          >
                                            <img
                                              src={item.cover_file}
                                              alt="cover buku"
                                              className="rounded-xl"
                                            />
                                          </div>
                                          <div
                                            className="p-2 min-h-[120px]"
                                            onClick={() =>
                                              this.gotoDetail(item.alias)
                                            }
                                          >
                                            <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                              {item.judul}
                                            </div>
                                            <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                              {item.penulis}
                                            </div>
                                            <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                              {item.penerbit}
                                            </div>
                                            <div className="stock mt-1 text-sm text-orange font-semibold">
                                              Stok: {item.terpakai}/{item.qty}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              })}
                          </>
                        )}
                    </Glider>
                  </div>

                  <div className="pl-4 mb-20 hidden md:block">
                    <Glider slidesToShow="5.3" slidesToScroll="1" draggable>
                      {/* <!-- Item Book --> */}
                      {Array.isArray(this.state.dataRekomendasi) &&
                        this.state.dataRekomendasi.length > 0 &&
                        this.state.flagBukuR && (
                          <>
                            {this.state.dataRekomendasi
                              .slice(0, 6)
                              .map((item) => {
                                if (item.alias !== this.state.params.id) {
                                  return (
                                    <>
                                      <div className="p-1">
                                        <div className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                                          <div
                                            className="h-[140px] overflow-hidden"
                                            onClick={() =>
                                              this.gotoDetail(item.alias)
                                            }
                                          >
                                            <img
                                              src={item.cover_file}
                                              alt="cover buku"
                                              className="rounded-xl"
                                            />
                                          </div>
                                          <div className="p-2 min-h-[120px]">
                                            <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                              {item.judul}
                                            </div>
                                            <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                              {item.penulis}
                                            </div>
                                            <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                              {item.penerbit}
                                            </div>
                                            <div className="stock mt-1 text-sm text-orange font-semibold">
                                              Stok: {item.terpakai}/{item.qty}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              })}
                          </>
                        )}
                    </Glider>
                  </div>
                </>
              )}
              {this.state.showAppNotInstalled && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-3xl p-8 w-[90%] max-w-md text-center shadow-xl">
                    <div className="text-5xl mb-4">📱</div>
                    <h2 className="text-xl font-bold mb-2">
                      Aplikasi Belum Terinstall
                    </h2>
                    <p className="text-gray-500 mb-6">
                      Untuk membaca konten ini, silakan install aplikasi
                      terlebih dahulu.
                    </p>

                    <button
                      onClick={() =>
                        (window.location.href =
                          "https://play.google.com/store/apps/details?id=com.bintangpusnas")
                      }
                      className={
                        "w-full " +
                        this.state.color +
                        " p-3 text-white font-semibold rounded-2xl mb-4"
                      }
                    >
                      Download Sekarang
                    </button>

                    <button
                      onClick={() =>
                        this.setState({ showAppNotInstalled: false })
                      }
                      className={
                        "w-full " +
                        this.state.color +
                        " p-3 text-white font-semibold rounded-2xl "
                      }
                    >
                      Tutup
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

export default WithNavigate;
